import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import BrandMark from "./BrandMark";
import NavDialog from "./NavDialog";
import { useSite } from "../hooks/useSite";
import useScrollDirection from "../hooks/useScrollDirection";

// Must match .ro-header height in site.css (desktop). Below this scrollY the
// header band overlaps the hero, so it always stays visible.
const HEADER_HEIGHT = 112;

export default function SiteHeader() {
  const { navOpen, setNavOpen } = useSite();
  const triggerRef = useRef(null);
  const location = useLocation();
  const { direction, atTop } = useScrollDirection({
    threshold: 8,
    topOffset: HEADER_HEIGHT,
    // Route change or dialog open/close resets direction to "up", so the
    // header is visible on a new page and stays visible after the nav closes
    // until the user actually scrolls down again.
    resetKey: `${location.pathname}|${navOpen}`,
  });
  // Recomputed every render from navOpen: a "down" state captured before the
  // dialog opened must never leave the header hidden once it closes.
  const hidden = direction === "down" && !atTop && !navOpen;
  return (
    <>
      <header className={`ro-header${hidden ? " ro-header--hidden" : ""}`} data-hidden={hidden || undefined}>
        <div className="ro-header__inner">
          <BrandMark id="header" />
          <button
            ref={triggerRef}
            type="button"
            className="ro-burger"
            aria-label="Open navigation"
            aria-haspopup="dialog"
            aria-expanded={navOpen}
            aria-controls="ro-navigation"
            onClick={() => setNavOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>
      <NavDialog open={navOpen} onClose={() => setNavOpen(false)} returnFocusTo={triggerRef} />
    </>
  );
}
